import Section from "../components/Section";
import devphoto from "../assets/images/dev_pr.png";
import SkillProgress from "../components/SkillProgress";
function About() {
  const rediPintrest = () => {
    window.location.href = "https://pin.it/1agZp2YNs";
  };

  const rediFacebook = () => {
    window.location.href = "https://www.facebook.com/devdavid.welengenzu.3";
  };

  const rediInstagram = () => {
    window.location.href =
      "https://www.instagram.com/dev__well/profilecard/?igsh=czc4dXlucmU1aWx1";
  };

  const rediLinkdin = () => {
    window.location.href = " https://www.linkedin.com/in/david-wele-b4509621b";
  };

  const skills = [
    { skill: "Design (Adobe XD, Photoshop)", percentage: 80 },
    { skill: "Frontend (React, Tailwind)", percentage: 70 },
    {
      skill: "Community M (Business suite, Ph)",
      percentage: 70,
    },
    { skill: "Consulting Info (Audit, Optimisation)", percentage: 70 },
  ];
  return (
    <Section>
      {" "}
      <h2 className="text-3xl font-bold text-center text-blue-600  mb-8">
        À Propos <strong className="text-orange-400">de moi</strong>
      </h2>{" "}
      <div className=" ">
        <div className=" md:flex md:flex-row p-2 md:space-x-3 md:justify-between items-center space-y-4">
          <div className=" flex flex-col items-center">
            <div className=" w-full flex justify-center items-center">
              <div
                className=" md:w-[350px] w-[300px] md:h-[350px] h-[300px] bg-gray-100 dark:bg-[#010138]
                               flex justify-center items-center rounded-t-lg shadow-lg"
              >
                <div>
                  <img
                    src={devphoto}
                    alt=""
                    className=" w-full h-full shadow-xl"
                  />
                </div>
              </div>
            </div>
            <div
              className=" flex flex-row justify-center space-x-4 mt-0 rounded-b-lg shadow-lg
            text-2xl font-bold text-white bg-blue-600 p-3 md:w-[350px] w-[300px]"
            >
              <div>
                <button onClick={rediFacebook}>
                  <i className=" fab fa-facebook"></i>
                </button>
              </div>
              <div>
                <button onClick={rediInstagram}>
                  <i className=" fab fa-instagram"></i>
                </button>
              </div>
              <div>
                <button onClick={rediPintrest}>
                  <i className=" fab fa-pinterest"></i>
                </button>
              </div>
              <div>
                <button onClick={rediLinkdin}>
                  <i className=" fab fa-linkedin"></i>
                </button>
              </div>
            </div>
          </div>
          <div className=" p-4   rounded-md dark:md:bg-[#010138] flex justify-center shadow-lg">
            <p
              className="text-blue-600 dark:text-white font-normal mb-6 max-w-2xl  mx-auto md:text-xl md: md:m-3
                       text-justify w-[360px] md:w-[700px]"
            >
              {" "}
              Je suis un professionnel polyvalent avec une passion pour la
              création d’expériences numériques et l’optimisation des systèmes
              informatiques. <br /> En tant que Designer UI/UX et Graphiste, je
              conçois des interfaces utilisateur attrayantes et intuitives.{" "}
              <br />
              Je maitrise des outils de design tels que Adobe XD, Photoshop,
              Illustrator. <br /> Sur le Développement je sui à l'aise avec le
              JS(React),PHP(laravel) et autres technologies de base. <br /> Je
              joue également le rôle de community manager et consultant
              informmatique.{" "}
            </p>{" "}
          </div>
        </div>{" "}
        <div className="md:grid md:grid-cols-2 items-center mt-8 ">
          {skills.map((item) => (
            <div className="dark:bg-[#010138] m-2  rounded-md bg-white shadow-lg">
              <SkillProgress
                key={item.skill}
                skill={item.skill}
                percentage={item.percentage}
              />
            </div>
          ))}{" "}
        </div>
      </div>{" "}
    </Section>
  );
}
export default About;

/*
import Section from "../components/Section";
import SkillProgress from "../components/SkillProgress";
function About() {
  const skills = [
    { skill: "Design (Figma, Photoshop)", percentage: 90 },
    { skill: "Frontend (React, Tailwind)", percentage: 95 },
    { skill: "Community Management (Hootsuite, Canva)", percentage: 85 },
    { skill: "Consulting Informatique (Audit, Optimisation)", percentage: 80 },
  ];

  return (
    <Section>
      {" "}
      <h2 className="text-3xl font-bold text-center mb-8 text-gray-900 dark:text-gray-200">
        {" "}
        À Propos{" "}
      </h2>{" "}
      <p className="text-gray-700 dark:text-gray-400 mb-8 text-center max-w-2xl mx-auto">
        {" "}
        Je suis un professionnel polyvalent avec une passion pour la création
        d’expériences numériques et l’optimisation des systèmes informatiques.{" "}
      </p>{" "}
      <div className="max-w-2xl mx-auto">
        {" "}
        <h3 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-200">
          {" "}
          Mes Compétences{" "}
        </h3>{" "}
        {skills.map((item) => (
          <SkillProgress
            key={item.skill}
            skill={item.skill}
            percentage={item.percentage}
          />
        ))}{" "}
      </div>{" "}
    </Section>
  );
}
export default About;
*/
